import { useEffect, useRef, useState } from 'react';

const normalizeText = (text: string): string => {
    if (!text) return '';
    return text
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/-/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
};
import { useLocation, useParams } from 'react-router-dom';
import {
    asyncGetSurvey,
    asyncPostSurveyResponse,
    asyncGetValidationCedula,
    asyncGetSurveyResponseAnswer,
    asyncGetAnswerByParent,
    asyncValidationAnswerList,
    asyncGetTemporalPrevisoraComplete,
} from '../../../../../services/survey.service';
import { useDispatch } from 'react-redux';
import { typesRedux } from '../../../../../shared/types/typesRedux';
import {
    allowedUrlParamToQuestionDescription,
    isRequiredAnswerComplete,
} from '../../../../../shared/utils/survey';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';

interface Props {
    onSave?: () => void;
    onChangeSurvey?: (survey: any) => void;
}

export const useTemporalPrevisora = ({ onSave, onChangeSurvey }: Props) => {
    const dispatch: any = useDispatch();
    const { idSurvey } = useParams();
    const location = useLocation();

    const [survey, setSurvey] = useState<any>(undefined);
    const [questions, setQuestions] = useState<any[]>([]);
    const [answers, setAnswers] = useState({});
    const [isCedulaValid, setIsCedulaValid] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    

    const [questionCedula, setQuestionCedula] = useState<any>();

    const [questionN1, setQuestionN1] = useState<string>();
    const [questionN2, setQuestionN2] = useState<string>();
    const [questionN3, setQuestionN3] = useState<string>();
    const [dataUser, setDataUser] = useState<string>();

    const [questionIdApplicable, setQuestionIdApplicable] = useState<string>();
    const [answerApplicable, setAnswerApplicable] = useState<string>();
    const [isApplicable, setIsApplicable] = useState<boolean>(false);
    const [answerN2, setAnswerN2] = useState<string>();
    const [answerN3, setAnswerN3] = useState<string>();
    const [areasExcluirId, setAreasExcluirId] = useState<any[]>([]);
    const [isEndSurvey, setIsEndSurvey] = useState<boolean>(false);
    const [descriptionArea, setDescriptionArea] = useState<string>();

    //New division by questions
    const [questionsPersonalData, setQuestionsPersonalData] = useState<any[]>(
        []
    );
    const [questionsAreasData, setQuestionsAreasData] = useState<any[]>([]);
    const [questionsSurveyData, setQuestionsSurveyData] = useState<any[]>([]);
    // Lista 1: copia inicial completa (no se modifica) y su cantidad
    const [answersN1Initial, setAnswersN1Initial] = useState<any[]>([]);
    const [cantidadInicialLista1, setCantidadInicialLista1] =
        useState<number>(0);
    // Si include deja la lista 1 vacía, se pasa a exclude y se mantiene
    const modeLista1Ref = useRef<'include' | 'exclude'>('include');
    // Evita re-ejecutar el filtro cuando el propio efecto actualiza questionsAreasData
    const skipAreasFilterEffectRef = useRef(false);

    const queryParams = new URLSearchParams(location.search);

    const getCurrentPeriodDates = () => {
        const endDate = new Date();
        endDate.setHours(23, 59, 59, 999);
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 4);
        startDate.setHours(0, 0, 0, 0);

        const formatDate = (date: Date) => date.toISOString();

        return {
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
        };
    };

    useEffect(() => {
        asyncGetSurvey(idSurvey, true)
            .then((body: any) => {
                if (body.items !== undefined && onChangeSurvey) {
                    setSurvey(body?.items);
                    onChangeSurvey(body?.items);
                }
            })
            .finally(() => setLoading(false));
    }, [idSurvey]);

    useEffect(() => {
        setQuestions(survey?.questions || []);
    }, [survey]);

    useEffect(() => {
        dispatch({
            type: typesRedux.SHOW_NAVBAR,
            payload: false,
        });
    }, []);

    useEffect(() => {
        if (!questions?.length) return;

        const paramUrlAnswers: Record<string, any> = {};
        let hasNewAnswer = false;

        const safeDecode = (input: string) => {
            try {
                return decodeURIComponent(input);
            } catch (e) {
                return '';
            }
        };

        const sanitize = (input: string) => {
            return safeDecode(input)
                .replace(/[<>]/g, '')
                .trim()
                .substring(0, 100);
        };

        const isValidAnswerForQuestion = (type: string, value: any) => {
            switch (type) {
                case 'only':
                case 'list-only':
                case 'validation-reference':
                case 'text':
                    return typeof value === 'string' && value.length < 500;
                case 'multiple':
                    return (
                        Array.isArray(value) &&
                        value.every((v) => typeof v === 'string')
                    );
                case 'linear':
                    return !isNaN(parseInt(value));
                default:
                    return typeof value === 'string';
            }
        };

        queryParams.forEach((value, key) => {
            const expectedDescription =
                allowedUrlParamToQuestionDescription?.[key];
            if (!expectedDescription) return;

            const matchedQuestion = questions.find(
                (item) =>
                    item?.description?.trim().toLowerCase() ===
                    expectedDescription.trim().toLowerCase()
            );

            if (matchedQuestion && !(answers as any)[matchedQuestion.id]) {
                const cleanedValue = sanitize(value);

                if (
                    !isValidAnswerForQuestion(
                        matchedQuestion.type,
                        cleanedValue
                    )
                ) {
                    return;
                }

                paramUrlAnswers[matchedQuestion.id] = {
                    idQuestion: matchedQuestion.id,
                    answer: cleanedValue,
                    type: matchedQuestion.type,
                };

                hasNewAnswer = true;
            }
        });

        if (hasNewAnswer) {
            setAnswers((prev) => ({
                ...prev,
                ...paramUrlAnswers,
            }));
        }

        groupSurveyQuestions(questions);
    }, [questions]);

    const groupSurveyQuestions = (questions: any[]) => {
        const cedulaQuestion = questions.find(
            (q: any) =>
                q.description ===
                'Digite su número de cédula sin puntos ni comas'
        );
        if (cedulaQuestion) setQuestionCedula(cedulaQuestion.id);
    };

    // Filtra un listado con asyncValidationAnswerList.
    // mode 'include' (listas 1 y 2): deja solo los IDs retornados.
    // mode 'exclude' (lista 3): excluye los IDs retornados y deja el resto.
    // Si el servicio retorna [] (o no es array), no filtra y muestra todos los items.
    // Si retorna la misma cantidad de IDs que se enviaron (lista 3), la encuesta está finalizada.
    // idsAnswersToSend: si se indica, se envían esos IDs al servicio (p.ej. lista 1 inicial)
    // y answerItems es la base sobre la que se aplica el filtro para el select.
    const filtrarRespuestasPorValidacion = async (
        answerItems: any[],
        numberlist: number,
        document?: string,
        surveyIdParam?: string,
        mode: 'include' | 'exclude' = 'include',
        idsAnswersToSend?: string[]
    ) => {
        if (!Array.isArray(answerItems) || answerItems.length === 0) return [];
        if (!document || !surveyIdParam) return answerItems;

        const idsAnswers =
            Array.isArray(idsAnswersToSend) && idsAnswersToSend.length > 0
                ? idsAnswersToSend
                : answerItems.map((a: any) => a.id);

        const idsServicio = await asyncValidationAnswerList({
            document,
            surveyId: surveyIdParam,
            numberlist,
            idsAnswers,
        });

        if (!Array.isArray(idsServicio) || idsServicio.length === 0) {
            return answerItems;
        }

        if (
            numberlist === 1 &&
            idsServicio.length === idsAnswers.length
        ) {
            setIsEndSurvey(true);
            setIsCedulaValid(false);
            try {
                await asyncGetTemporalPrevisoraComplete(document);
            } catch (e) {
                console.error(
                    'No se pudo marcar el usuario como completado:',
                    e
                );
            }
            ToastSwal.fire({
                text: 'Has finalizado el proceso de calificación de las áreas con las que interactuaste, gracias por tu activa participación',
                icon: 'success',
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                position: 'center',
            });
            return [];
        }

        const idsSet = new Set(idsServicio);
        if (mode === 'exclude') {
            return answerItems.filter((a: any) => !idsSet.has(a.id));
        }
        return answerItems.filter((a: any) => idsSet.has(a.id));
    };

    // Filtra opciones de Nivel 2 (Gerencia) que no tengan hijos válidos en Nivel 3
    // Un hijo de Nivel 3 es válido si, después de aplicar las reglas actuales,
    // queda al menos un área disponible: excluir área propia (answerN3) y áreas ya calificadas (areasExcluirId)
    const filterNivel2ByAvailableAreas = async (
        nivel2Items: any[],
        excluirIds: any[] = areasExcluirId
    ) => {
        if (!Array.isArray(nivel2Items) || nivel2Items.length === 0) return [];
        // Si aún no está configurada la pregunta de nivel 3, no filtramos para no romper el flujo
        if (!questionN3) return nivel2Items;

        const answerN3Norm = normalizeText(answerN3 || '');
        const checks = await Promise.all(
            nivel2Items.map(async (n2: any) => {
                try {
                    const resN3 = await asyncGetAnswerByParent(
                        questionN3,
                        n2.id
                    );
                    const itemsN3 = resN3?.items || [];
                    // Aplica los mismos filtros usados al poblar N3
                    const disponibles = itemsN3.filter(
                        (ans: any) =>
                            normalizeText(ans?.description) !== answerN3Norm &&
                            !excluirIds?.includes?.(ans?.id)
                    );
                    return disponibles.length > 0 ? n2 : null;
                } catch (e) {
                    console.warn(
                        'No se pudo validar áreas para la gerencia',
                        n2,
                        e
                    );
                    return null;
                }
            })
        );

        return checks.filter(Boolean);
    };

    // Filtra Nivel 1 (Vicepresidencia) por disponibilidad real de Nivel 2 (Gerencias)
    // Conserva únicamente aquellas N1 que, al cargar sus N2 y aplicar filterNivel2ByAvailableAreas,
    // aún tengan al menos una Gerencia con Áreas (N3) disponibles.
    const filterNivel1ByAvailableNivel2 = async (nivel1Items: any[]) => {
        if (!Array.isArray(nivel1Items) || nivel1Items.length === 0) return [];
        // Debe existir la pregunta de N2 para poder evaluar
        if (!questionN2) return nivel1Items;
        const checks = await Promise.all(
            nivel1Items.map(async (n1: any) => {
                try {
                    const resN2 = await asyncGetAnswerByParent(
                        questionN2,
                        n1.id
                    );
                    const itemsN2 = resN2?.items || [];
                    if (itemsN2.length === 0) return null;
                    const n2Validas = await filterNivel2ByAvailableAreas(
                        itemsN2
                    );
                    return n2Validas && n2Validas.length > 0 ? n1 : null;
                } catch (e) {
                    console.warn(
                        'No se pudo validar gerencias para la vice',
                        n1,
                        e
                    );
                    return null;
                }
            })
        );

        return checks.filter(Boolean);
    };

    // Efecto: Pre-filtrar las vice (N1) cuyo árbol N2->N3 queda vacío.
    useEffect(() => {
        if (skipAreasFilterEffectRef.current) {
            skipAreasFilterEffectRef.current = false;
            return;
        }

        const markAreasDataUpdateFromFilter = () => {
            skipAreasFilterEffectRef.current = true;
        };

        const aplicarFiltroN1 = async () => {
            // Necesitamos que existan las preguntas de N1, N2 y N3 y sus estructuras cargadas
            if (!questionN1 || !questionN2 || !questionN3) return;
            if (!questionsAreasData || questionsAreasData.length === 0) return;
            if (!dataUser || !idSurvey) return;

            const qN1 = questionsAreasData.find(
                (q: any) => q.id === questionN1
            );

            if (!qN1 || !Array.isArray(qN1.answers) || qN1.answers.length === 0)
                return;

            // Base de filtrado: siempre la lista 1 inicial completa
            // (cantidadInicialLista1 conserva el tamaño original para el payload)
            const baseN1 =
                answersN1Initial.length > 0 ? answersN1Initial : qN1.answers;
            const idsN1Iniciales =
                cantidadInicialLista1 > 0 && answersN1Initial.length > 0
                    ? answersN1Initial.map((a: any) => a.id)
                    : baseN1.map((a: any) => a.id);

            try {
                setLoading(true);

                let listaFinal: any[] = [];

                if (modeLista1Ref.current === 'exclude') {
                    // Ya se decidió exclude: siempre filtrar así (no pasar por include)
                    listaFinal = await filtrarRespuestasPorValidacion(
                        baseN1,
                        1,
                        dataUser,
                        idSurvey,
                        'exclude',
                        idsN1Iniciales
                    );
                } else {
                    listaFinal = await filtrarRespuestasPorValidacion(
                        baseN1,
                        1,
                        dataUser,
                        idSurvey,
                        'include',
                        idsN1Iniciales
                    );

                    // Include vacío → exclude
                    if (listaFinal.length === 0) {
                        listaFinal = await filtrarRespuestasPorValidacion(
                            baseN1,
                            1,
                            dataUser,
                            idSurvey,
                            'exclude',
                            idsN1Iniciales
                        );
                        modeLista1Ref.current = 'exclude';
                    } else {
                        // Validar árbol N1→N2→N3; si queda vacío → exclude
                        const n1Arbol =
                            await filterNivel1ByAvailableNivel2(listaFinal);
                        if (n1Arbol.length === 0) {
                            listaFinal = await filtrarRespuestasPorValidacion(
                                baseN1,
                                1,
                                dataUser,
                                idSurvey,
                                'exclude',
                                idsN1Iniciales
                            );
                            modeLista1Ref.current = 'exclude';
                        } else {
                            listaFinal = n1Arbol;
                        }
                    }
                }

                const idsFinalSet = new Set(listaFinal.map((a: any) => a.id));
                const currentAnswers = qN1.answers || [];
                const sameLength = listaFinal.length === currentAnswers.length;
                const sameIds =
                    sameLength &&
                    listaFinal.every(
                        (a, idx) => a.id === currentAnswers[idx]?.id
                    );

                if (!sameIds) {
                    markAreasDataUpdateFromFilter();
                    setQuestionsAreasData((prev: any[]) =>
                        prev.map((q: any) =>
                            q.id === questionN1
                                ? { ...q, answers: listaFinal }
                                : q
                        )
                    );
                }

                // Limpiar selección solo si ya no está en la lista final
                const currentN1 = (answers as any)[questionN1]?.answer;
                if (currentN1 && !idsFinalSet.has(currentN1)) {
                    setAnswers((prev) => {
                        const next = { ...prev };
                        if (questionN1) delete (next as any)[questionN1];
                        if (questionN2) delete (next as any)[questionN2];
                        if (questionN3) delete (next as any)[questionN3];
                        return next;
                    });
                    if (listaFinal.length > 0) {
                        ToastSwal.fire({
                            text: 'La Vicepresidencia seleccionada no tiene Gerencias ni Áreas disponibles para calificar. Por favor elige otra.',
                            icon: 'warning',
                            timer: 6000,
                            timerProgressBar: true,
                        });
                    }
                }
            } catch (e) {
                console.error('Error filtrando Nivel 1:', e);
            } finally {
                setLoading(false);
            }
        };

        // Ejecutar cuando cambian los criterios que afectan disponibilidad: exclusiones y área propia
        aplicarFiltroN1();
    }, [
        questionN1,
        questionN2,
        questionN3,
        questionsAreasData,
        answersN1Initial,
        areasExcluirId,
        answerN3,
        dataUser,
        idSurvey,
    ]);

    const handleChangeQuestion = async (data: any) => {
        // Guardar de inmediato para que el select no pierda el valor
        // mientras cargan N2/N3 (si no, valueProp vacío pisa la selección).
        if (data?.idQuestion) {
            setAnswers((prev) => ({ ...prev, [data.idQuestion]: data }));
        }

        if (data.idQuestion === questionIdApplicable) {
            noAplica(data);
        }
        const cedulaQuestion = questions.find(
            (q: any) =>
                q.description ===
                'Digite su número de cédula sin puntos ni comas'
        );

        if (cedulaQuestion && data.idQuestion === cedulaQuestion) {
            setIsCedulaValid(false);
        }
        if (data.idQuestion === questionN1 && questionN2 && answerN2) {
            setDescriptionArea('');
            // Limpiar selects dependientes hasta cargar los nuevos resultados
            setQuestionsAreasData((prev: any[]) =>
                prev.map((q: any) =>
                    q.id === questionN2 || q.id === questionN3
                        ? { ...q, answers: [] }
                        : q
                )
            );
            setAnswers((prev) => {
                const next = { ...prev };
                if (questionN2) delete (next as any)[questionN2];
                if (questionN3) delete (next as any)[questionN3];
                return next;
            });
            try {
                setLoading(true);
                const resNivel2 = await asyncGetAnswerByParent(
                    questionN2,
                    data.answer
                );

                if (
                    !resNivel2 ||
                    !resNivel2.items ||
                    resNivel2.items.length === 0
                ) {
                    console.warn('No hay gerencias para la vice seleccionada');
                    return;
                }
                // Filtrar Gerencias (Nivel 2) que no tienen Áreas (Nivel 3) disponibles
                const n2Filtradas = await filterNivel2ByAvailableAreas(
                    resNivel2.items
                );
                // Filtrar lista 2: solo IDs permitidos por el servicio
                const n2Permitidas = await filtrarRespuestasPorValidacion(
                    n2Filtradas,
                    2,
                    dataUser,
                    idSurvey
                );
                if (!n2Permitidas || n2Permitidas.length === 0) {
                    setAnswers((prev) => {
                        const next = { ...prev };
                        if (questionN2) delete (next as any)[questionN2];
                        if (questionN3) delete (next as any)[questionN3];
                        return next;
                    });
                    ToastSwal.fire({
                        text: 'La Vicepresidencia seleccionada no tiene Gerencias con Áreas disponibles para calificar.',
                        icon: 'warning',
                        timer: 6000,
                        timerProgressBar: true,
                    });
                    return;
                }
                setAnswerByArea(n2Permitidas, questionN2, answerN2);
                setAnswers((prev) => {
                    const next = { ...prev };
                    if (questionN3) delete (next as any)[questionN3];
                    return next;
                });
            } catch (err) {
                console.error('Error cargando nivel 2:', err);
            } finally {
                setLoading(false);
            }
        }

        if (data.idQuestion === questionN2 && questionN3 && answerN3) {
            setDescriptionArea('');
            setQuestionsAreasData((prev: any[]) =>
                prev.map((q: any) =>
                    q.id === questionN3 ? { ...q, answers: [] } : q
                )
            );
            setAnswers((prev) => {
                const next = { ...prev };
                if (questionN3) delete (next as any)[questionN3];
                return next;
            });
            try {
                setLoading(true);
                const resNivel3 = await asyncGetAnswerByParent(
                    questionN3,
                    data.answer
                );
                if (
                    !resNivel3 ||
                    !resNivel3.items ||
                    resNivel3.items.length === 0
                ) {
                    console.warn('No hay áreas para la gerencia seleccionada');
                    return;
                }
                // Lista 3: solo se gestiona con filtrarRespuestasPorValidacion
                const n3Filtradas = await filtrarRespuestasPorValidacion(
                    resNivel3.items,
                    3,
                    dataUser,
                    idSurvey,
                    'exclude'
                );
                setQuestionsAreasData((prev: any[]) =>
                    prev.map((q: any) =>
                        q.id === questionN3
                            ? { ...q, answers: n3Filtradas }
                            : q
                    )
                );
            } catch (err) {
                console.error('Error cargando nivel 3:', err);
            } finally {
                setLoading(false);
            }
        }

        if (data.idQuestion === questionN3 && data.answer) {
            const area =
                questionsAreasData.find((q: any) => q.id === data.idQuestion) ||
                questions.find((q: any) => q.id === data.idQuestion);
            const areaAns = area?.answers?.find(
                (a: any) => a.id === data.answer
            );
            setDescriptionArea(areaAns?.label || '');
        }
    };

    // Solo para lista 2 (Gerencia). La lista 3 no se modifica aquí.
    const setAnswerByArea = (
        res: any,
        questionCompare: string,
        _nivelPersonalData: string
    ) => {
        if (questionCompare === questionN3) return;

        setQuestionsAreasData((prev: any[]) =>
            prev.map((q: any) =>
                q.id === questionCompare ? { ...q, answers: res } : q
            )
        );
    };

    const isInvalid = () => {
        if (!isCedulaValid) return true;

        let questionEvaluated: any[] = [];
        if (isApplicable) {
            questionEvaluated = [...questionsSurveyData, ...questionsAreasData];
        } else {
            questionEvaluated = [...questionsAreasData];
        }

        return questionEvaluated
            .filter((q) => q.required)
            .some(
                (q) =>
                    !isRequiredAnswerComplete(
                        q.type,
                        (answers as any)[q.id]
                    )
            );
    };

    const checkVicepresidencyComplete = async (
        viceActualId: string,
        document: string
    ): Promise<boolean> => {
        if (!questionN2 || !questionN3 || !document) return false;

        try {
            const resN2 = await asyncGetAnswerByParent(questionN2, viceActualId);
            const managements = resN2?.items || [];

            const areaIdsOfThisVP = new Set<string>();
            const ownAreaNorm = normalizeText(answerN3 || '');

            for (const management of managements) {
                const resN3 = await asyncGetAnswerByParent(
                    questionN3,
                    management.id
                );
                const areas = resN3?.items || [];
                areas.forEach((ans: any) => {
                    if (normalizeText(ans.description) !== ownAreaNorm) {
                        areaIdsOfThisVP.add(ans.id);
                    }
                });
            }

            if (areaIdsOfThisVP.size === 0) return true;

            const { startDate, endDate } = getCurrentPeriodDates();
            const ratedAreas = await asyncGetSurveyResponseAnswer(
                document,
                questionN3,
                startDate,
                endDate
            );

            const ratedAreasOfThisVP =
                ratedAreas?.questionAnswers?.filter((ans: any) =>
                    areaIdsOfThisVP.has(ans.answer?.id)
                ) || [];

            return ratedAreasOfThisVP.length >= areaIdsOfThisVP.size;
        } catch (e) {
            console.error('Error checking VP complete:', e);
            return false;
        }
    };

    const onClickSave = async () => {
        if (!isApplicable && isInvalid()) return;

        const resAnswers = getResAnswers();
        const data: any = {
            survey: idSurvey,
            response: resAnswers,
        };

        const viceActualId = (answers as any)[questionN1!]?.answer;

        setLoading(true);

        await asyncPostSurveyResponse(data)
            .then(async (body: any) => {
                if (body.items.ok) {
                    if (isEndSurvey && onSave) {
                        window.scrollTo(0, 0);
                        onSave();
                        setAnswers({});
                    } else {
                        const answersToRemoveAreas = questionsAreasData.map(
                            (q) => q.id
                        );
                        const answersToRemoveSurvey =
                            questionsSurveyData.map((q) => q.id);
                        const filteredAnswers = Object.fromEntries(
                            Object.entries(answers).filter(
                                ([, value]: any) =>
                                    !answersToRemoveAreas.includes(
                                        value.idQuestion
                                    ) &&
                                    !answersToRemoveSurvey.includes(
                                        value.idQuestion
                                    )
                            )
                        );
                        setAnswers(filteredAnswers);

                        let isVpComplete = false;
                        if (dataUser && viceActualId) {
                            isVpComplete = await checkVicepresidencyComplete(
                                viceActualId,
                                dataUser
                            );
                        }
                        if (isVpComplete) {
                            ToastSwal.fire({
                                text: '¡Has terminado con la calificación de todas las áreas de esta Vicepresidencia. Te invitamos a continuar calificando áreas de otras Vicepresidencias.',
                                icon: 'success',
                                showConfirmButton: true,
                                confirmButtonText: 'Entendido',
                                position: 'center',
                            });
                        } else {
                            ToastSwal.fire({
                                text: 'Calificación guardada exitosamente. Puedes continuar calificando otras áreas.',
                                icon: 'success',
                                showConfirmButton: true,
                                confirmButtonText: 'Continuar',
                                position: 'center',
                            });
                        }

                        // Reiniciar listas y recargar como al validar el documento
                        setIsApplicable(false);
                        setDescriptionArea('');
                        setQuestionsAreasData([]);
                        setQuestionsSurveyData([]);
                        setAreasExcluirId([]);
                        setAnswersN1Initial([]);
                        setCantidadInicialLista1(0);
                        modeLista1Ref.current = 'include';

                        if (dataUser) {
                            await documentValidate(dataUser);
                        }
                    }
                }
            })
            .finally(() => setLoading(false));
    };

    const getResAnswers = () => {
        const resAnswers: any = {};
        questions.forEach((q: any) => {
            if ((answers as any)[q.id]) {
                resAnswers[q.id] = (answers as any)[q.id];
            }
        });
        return resAnswers;
    };

    const documentValidate = async (document: string) => {
        if (!document) return;

        const personalData: any = await asyncGetValidationCedula(document);
        if (
            (!personalData &&
                !personalData?.items &&
                personalData.items.length === 0) ||
            personalData.errors
        ) {
            ToastSwal.fire({
                text: 'La cédula ingresada no se encuentra en el listado autorizado. Le recomendamos contactar al área encargada para verificar su acceso.',
                icon: 'error',
                showConfirmButton: true,
                timer: 9000,
                timerProgressBar: true,
                confirmButtonText: 'Entendido',
            });
            setIsCedulaValid(false);
        } else {
            if(personalData.items.status === 'COMPLETED'){
                ToastSwal.fire({
                    text: 'Actualmente ya se realizo la calificación de las encuestas disponibles asociadas al número de documento, si tiene algún inconveniente; le recomendamos contactar al área encargada para cualquier verificación. ',
                    icon: 'info',
                    showConfirmButton: true,
                    confirmButtonText: 'Entendido',
                });
                setIsCedulaValid(false);
                return;
            }else{
                setIsCedulaValid(true);
                setDataUser(personalData.items.cedula);
                await setQuestionsAndAnswers(questions, personalData.items);            
            }            
        }
    };

    useEffect(() => {
        const verificarEncuestaCompleta = async () => {
            if (!dataUser || !questionN3) {
                return;
            }

            const qN3 = questions.find((q: any) => q.id === questionN3);
            if (!qN3 || !qN3.answers) {
                return;
            }

            const areaPropiaNorm = normalizeText(answerN3 || '');
            const areasDisponibles = qN3.answers.filter(
                (ans: any) => normalizeText(ans.description) !== areaPropiaNorm
            );
            const totalAreas = areasDisponibles.length;

            const { startDate, endDate } = getCurrentPeriodDates();
            const areasCalificadas = await asyncGetSurveyResponseAnswer(
                dataUser,
                questionN3,
                startDate,
                endDate
            );
            const totalCalificadas = areasCalificadas?.questionAnswers?.length || 0;

            if (totalCalificadas >= totalAreas && totalAreas > 0) {
                setIsCedulaValid(false);
                ToastSwal.fire({
                    text: 'Usted ya ha completado la calificación de todas las áreas disponibles. No puede ingresar nuevamente a la encuesta.',
                    icon: 'info',
                    showConfirmButton: true,
                    confirmButtonText: 'Entendido',
                });
            }
        };

        verificarEncuestaCompleta();
    }, [dataUser, questionN3, questions, answerN3]);

    const GetSurveyResponseAnswer = async (
        document: string,
        questionN3: string,
        answersTotalAreas: number
    ): Promise<any[]> => {
        if (!questionN3) return [];

        const { startDate, endDate } = getCurrentPeriodDates();
        const areasAnsPre = await asyncGetSurveyResponseAnswer(
            document,
            questionN3,
            startDate,
            endDate
        );
        if (
            areasAnsPre &&
            areasAnsPre.questionAnswers &&
            areasAnsPre.questionAnswers.length > 0
        ) {
            const areasExcluir = areasAnsPre.questionAnswers.map(
                (ans: any) => ans.answer.id
            );
            setAreasExcluirId(areasExcluir);
            if (
                answersTotalAreas ===
                areasAnsPre.questionAnswers.length + 1
            ) {
                setIsEndSurvey(true);
            } else if (
                answersTotalAreas === areasAnsPre.questionAnswers.length
            ) {
                setIsCedulaValid(false);
                ToastSwal.fire({
                    text: 'Actualmente ya se realizo la calificación de las encuestas disponibles asociadas al número de documento, si tiene algún inconveniente; Le recomendamos contactar al área encargada para cualquier verificación.',
                    icon: 'error',
                    showConfirmButton: true,
                    timer: 9000,
                    timerProgressBar: true,
                    confirmButtonText: 'Entendido',
                });
            }
            return areasExcluir;
        }

        setAreasExcluirId([]);
        return [];
    };

    const setQuestionsAndAnswers = async (
        questions: any,
        personalData: any
    ) => {
        const { nivel_1, nivel_2, nivel_3, nombre, cedula, correo, tipo_vinculacion } = personalData;

        const personalDataQs = questions
            .filter((q: any) =>
                [
                    'Nombre',
                    'Vicepresidencia a la que pertenece',
                    'Gerencia a la que pertenece',
                    'Subgerencia o sucursal Área a la que pertenece',
                    'Correo',
                    'Tipo de vinculacion',
                ].includes(q.description)
            )
            .map((q: any) => {
                let value = '';
                switch (q.description) {
                    //fields user
                    case 'Nombre':
                        value = nombre;
                        q.locked = true;
                        break;
                    case 'Vicepresidencia a la que pertenece':
                        value = nivel_1;
                        q.locked = true;
                        break;
                    case 'Gerencia a la que pertenece':
                        value = nivel_2;
                        setAnswerN2(nivel_2);
                        q.locked = true;
                        break;
                    case 'Subgerencia o sucursal Área a la que pertenece':
                        value = nivel_3;
                        setAnswerN3(nivel_3);
                        q.locked = true;
                        break;
                    case 'Correo':
                        value = correo || '';
                        q.locked = true;
                        break;
                    case 'Tipo de vinculacion':
                        value = tipo_vinculacion || '';
                        q.locked = true;
                        break;
                }
                setAnswers((prev) => ({
                    ...prev,
                    [q.id]: {
                        idQuestion: q.id,
                        answer: value,
                        type: q.type,
                    },
                }));
                return { ...q, answer: value };
            });

        let answersTotalAreas = 0;
        let questionN3Id = '';
        let areasQs = questions
            .filter((q: any) =>
                [
                    'Seleccione Vicepresidencia a calificar',
                    'Seleccione Gerencia a calificar',
                    'Seleccione el Área a calificar',
                    '¿Recibió servicios del área durante el primer semestre de 2026?',
                ].includes(q.description)
            )
            .map((q: any) => {
                switch (q.description) {
                    case 'Seleccione Vicepresidencia a calificar': {
                        const n1Inicial = [...(q.answers || [])];
                        setQuestionN1(q.id);
                        setAnswersN1Initial(n1Inicial);
                        setCantidadInicialLista1(n1Inicial.length);
                        modeLista1Ref.current = 'include';
                        break;
                    }
                    case 'Seleccione Gerencia a calificar':
                        setQuestionN2(q.id);
                        return { ...q, answers: [] };
                    case 'Seleccione el Área a calificar': {
                        const areaPropiaNorm = normalizeText(nivel_3);
                        const areasDisponibles = (q.answers || []).filter(
                            (ans: any) =>
                                normalizeText(ans.description) !==
                                areaPropiaNorm
                        );
                        answersTotalAreas = areasDisponibles.length;
                        questionN3Id = q.id;
                        setQuestionN3(q.id);
                        return { ...q, answers: [] };
                    }
                    case '¿Recibió servicios del área durante el primer semestre de 2026?':
                        setQuestionIdApplicable(q.id);
                        const findAnswerAplica = q.answers.find(
                            (ans: any) => ans.description === 'Aplica'
                        );
                        if (findAnswerAplica?.id)
                            setAnswerApplicable(findAnswerAplica?.id);
                        break;
                    default:
                        break;
                }
                return { ...q };
            });

        // Filtrar lista 1 para el select; al servicio se envían los IDs iniciales
        const qN1Area = areasQs.find(
            (q: any) =>
                q.description === 'Seleccione Vicepresidencia a calificar'
        );
        if (qN1Area?.answers?.length && cedula && idSurvey) {
            const idsN1Iniciales = qN1Area.answers.map((a: any) => a.id);
            let n1Permitidas = await filtrarRespuestasPorValidacion(
                qN1Area.answers,
                1,
                cedula,
                idSurvey,
                'include',
                idsN1Iniciales
            );
            if (n1Permitidas.length === 0) {
                n1Permitidas = await filtrarRespuestasPorValidacion(
                    qN1Area.answers,
                    1,
                    cedula,
                    idSurvey,
                    'exclude',
                    idsN1Iniciales
                );
                modeLista1Ref.current = 'exclude';
            }
            areasQs = areasQs.map((q: any) =>
                q.id === qN1Area.id ? { ...q, answers: n1Permitidas } : q
            );
        }

        if (questionN3Id) {
            await GetSurveyResponseAnswer(
                cedula,
                questionN3Id,
                answersTotalAreas
            );
        }

        const surveyQs = questions.filter(
            (q: any) =>
                !personalDataQs.some((p: any) => p.id === q.id) &&
                !areasQs.some((a: any) => a.id === q.id) &&
                !['Digite su número de cédula sin puntos ni comas'].includes(
                    q.description
                )
        );

        setQuestionsPersonalData(personalDataQs);
        setQuestionsAreasData(areasQs);
        setQuestionsSurveyData(surveyQs);
        setIsApplicable(false);
        setDescriptionArea('');

        return areasQs;
    };

    const noAplica = async (answer: any) => {
        setIsApplicable(false);
        if (answer.answer === answerApplicable) setIsApplicable(true);
    };

    return {
        survey,
        questions,
        answers,

        loading,
        handleChangeQuestion,
        documentValidate,
        onClickSave,
        isInvalid,

        isCedulaValid,
        questionsPersonalData,
        questionsAreasData,
        questionsSurveyData,
        questionCedula,

        isEndSurvey,
        isApplicable,
        descriptionArea,
        questionN3,
    };
};
